import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=5b386401&"
import script from "./pie.vue?vue&type=script&lang=ts&"
export * from "./pie.vue?vue&type=script&lang=ts&"
import style0 from "./pie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports